import React, { FC } from 'react';
import {
	Container as ModalContainer,
	Content as ModalContent,
	Footer as ModalFooter,
	Header as ModalHeader,
	ModalBoxRenderProps,
} from 'components/ModalBox';
import { red } from '../Color';
import { codes } from '../../data/translations';
import { Button } from '../Button';
import { FlexGrid } from '../FlexGrid';
import { useTranslationAPI } from '../../modules/translations';
import { ExclamationCircleO } from '../Icons/ExclamationCircleO';
import { Typography } from '../Typography';
import { connectModuleCodes } from '../../data/translations/connectModuleCodes';
import { MaintenanceProps } from './types';
import { formatMaintenanceDateTime } from './utils';


type ConnectorDetailDeleteModalProps = {
	modalRenderProps: ModalBoxRenderProps;
	maintenanceProps: MaintenanceProps
};

export const MaintenanceWarningModal: FC<React.PropsWithChildren<ConnectorDetailDeleteModalProps>> = ({
	modalRenderProps,
	maintenanceProps,
}) => {
	const { translate } = useTranslationAPI();
	const dateTime = formatMaintenanceDateTime(maintenanceProps.maintenanceDateTimeUtc);


	return (
		<ModalContainer>
			<ModalHeader
				{...modalRenderProps}
				title={translate(connectModuleCodes.helloFlexWillNotBeAvailableModalTitle)}
			/>
			<ModalContent useContentHeight>
				<FlexGrid
					gap='small'
					column
				>
					<FlexGrid
						center
						hrCenter
					>
						<ExclamationCircleO
							height='32px'
							width='32px'
							fill={red[7]}
						/>
					</FlexGrid>
					<Typography align='center'>
						{!maintenanceProps.maintenanceIsRunning && (
							<>
								{translate(connectModuleCodes.platformHasBeenDisabledSince)}{' '}{dateTime}
							</>
						)}
						{maintenanceProps.maintenanceIsRunning && (
							<>
								{translate(connectModuleCodes.helloFlexWillNotBeAvailableMessage, [dateTime])}
							</>
						)}
					</Typography>
				</FlexGrid>
			</ModalContent>
			<ModalFooter>
				<FlexGrid
					spaceBetween
					gap='tiny'
				>
					<Button
						primary
						dataTestId='ok'
						onClick={modalRenderProps.onClose}
					>
						{translate(codes.ok)}
					</Button>
				</FlexGrid>
			</ModalFooter>
		</ModalContainer>
	);
};
